import React from 'react';
import PropTypes from 'prop-types';
import { getStageSectionData, getAddInfoSectionData, getStageCloseSectionData, getStageCloseSectionDataForCardBrand } from './configStructure'
import { handlePrecision } from 'Utils/formatting.js';
import './StageSection.scss'
import moment from 'moment';

const StageSection = (props) => {
    let formattedFields = props.fields;
    let stageSectionData;
    if(props.isStageClose) {
        stageSectionData = (props.eventCode === 'STAGE_CLOSE' && props?.fields?.cardBrandResponseDueDate) ? getStageCloseSectionDataForCardBrand(): getStageCloseSectionData() ; 
    }
    else if(props.isNewStage){
        stageSectionData = getStageSectionData();
    }
    else {
        stageSectionData = getAddInfoSectionData();
    }
    const momentDateFormat = props.dateFormat ? props.dateFormat.replace(/dd/g, 'DD').replace(/yyyy/g, 'YYYY').replace(/yy/g, 'YY') : 'MMM DD, YYYY';
    const getStageCloseValues = (content) => {
        switch (content.displayType) {
            case "CASESTAGEID" :
                return `${formattedFields["stageId"]}`;
            case "STAGE":
               return props.stageName;
            case "IssuerResponseDueDate":
                return moment(new Date(parseInt(`${formattedFields["IssuerResponseDueDate"]}`))).format(momentDateFormat);
            case "cardBrandResponseDueDate":
                    return moment(new Date(parseInt(`${formattedFields["cardBrandResponseDueDate"]}`))).format(momentDateFormat);
            case "DISPOSITION":
                return `${formattedFields["disposition"]}`;
            default:
                return formattedFields[content.columnKey];
        }
    }


    const getNewStageValues = (content) => {
        switch (content.displayType) {
            case "CURRENCY":
                return handlePrecision(formattedFields[content.columnKey], 2) +" " + formattedFields["CurrencyCode"];
            case "STAGE":
                return props.stageName;
            case "REASON_CODE":
                return `${formattedFields[content.columnKey]} - ${formattedFields["DisputeReasonCodeDesc"]}`;
            default:
                return formattedFields[content.columnKey];
        }
    }
    return <div className="stage-section-card" >
        {formattedFields !== undefined && <div className="section-content">
            {stageSectionData.dataColumns?.map((content, index) => {

                return <div className="section-content-list" key={index}>
                        <span className="section-content-title">{content.name}</span>
                        <span key={index} className="section-content-value">{props.isStageClose ? getStageCloseValues(content) : getNewStageValues(content)}</span>
    
                    </div>
                
            })}
        </div>}

        {formattedFields !== undefined && <span className="divider">{" "}</span>}
        <div className="section-footer">
            <span className="section-footer-title">{stageSectionData.messageData.name}</span>{props.isStageClose ?
                formattedFields.CloseCaseReason === undefined ? <span className="section-footer-value">{"--"}</span> : <span className="section-footer-value">{formattedFields.CloseCaseReason}</span> :
                formattedFields.MemberMessage === undefined ? <span className="section-footer-value">{"--"}</span> : <span className="section-footer-value">{formattedFields.MemberMessage}</span>
            }
            
                
        </div>
    </div>
}

StageSection.propTypes = {
    openModal: PropTypes.func,
    fieldValues: PropTypes.array,
    sectionName: PropTypes.string,
    documents: PropTypes.array,
    scope: PropTypes.string,
    MsgToMerchant: PropTypes.string,
    MerchantPreferredMessage: PropTypes.string,
    stageName: PropTypes.string
};

StageSection.defaultProps = {
    stageName: ''
};

export default (StageSection);